import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Download: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 22.143 21.447"
    >
      <g id="Component_817_3" data-name="Component 817 – 3" opacity="1">
        <g
          id="Rectangle_1389"
          data-name="Rectangle 1389"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="20" height="20" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
        </g>
        <g id="download" transform="translate(2 1.304)">
          <path
            id="Path_5966"
            data-name="Path 5966"
            d="M17.572,20.882H4.821A2.521,2.521,0,0,1,2.25,18.421V15a.75.75,0,0,1,1.5,0v3.421a1.022,1.022,0,0,0,1.071.961h12.75a1.022,1.022,0,0,0,1.071-.961V15a.75.75,0,0,1,1.5,0v3.421A2.521,2.521,0,0,1,17.572,20.882Z"
            transform="translate(0 -0.738)"
            fill="currentColor"
          />
          <path
            id="Path_5967"
            data-name="Path 5967"
            d="M11.776,15.026a.748.748,0,0,1-.5-.191L6.5,10.559a.75.75,0,1,1,1-1.117l4.275,3.828,4.275-3.828a.75.75,0,1,1,1,1.117l-4.776,4.276A.748.748,0,0,1,11.776,15.026Z"
            transform="translate(-0.579 -0.476)"
            fill="currentColor"
          />
          <path
            id="Line_676"
            data-name="Line 676"
            d="M0,10.75A.75.75,0,0,1-.75,10V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V10A.75.75,0,0,1,0,10.75Z"
            transform="translate(11.519 3)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export default Download;
